import * as React from 'react';
import {connect} from 'react-redux';
import {
    ToggleConfidenceFilter,
    toggleConfidenceFilter,
    ToggleSynchronizedObjects,
    toggleSynchronizedObjects
} from '../actions';
import * as selectors from '../selectors';
import LocationalState, {LocationalConfidence} from '../LocationalState';
import {ConfidenceIcon} from './ConfidenceIcon';
import classNames = require('classnames');

interface DispatchProps {
    doToggleConfidenceFilter: ToggleConfidenceFilter;
    doToggleSynchronizedObjects: ToggleSynchronizedObjects;
}

interface StateProps {
    showConfidenceMissing: boolean;
    showConfidenceUncertain: boolean;
    showConfidenceConfident: boolean;
    showSynchronizedObjects: boolean;
}


type Props = StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        showConfidenceMissing: selectors.showConfidenceMissing(state),
        showConfidenceUncertain: selectors.showConfidenceUncertain(state),
        showConfidenceConfident: selectors.showConfidenceConfident(state),
        showSynchronizedObjects: selectors.showSynchronizedObjects(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doToggleConfidenceFilter: toggleConfidenceFilter,
    doToggleSynchronizedObjects: toggleSynchronizedObjects
});

class Component extends React.Component<Props, {}> {

    render() {
        const {showConfidenceMissing, showConfidenceUncertain, showConfidenceConfident, showSynchronizedObjects} = this.props;
        const checkedIconClass = 'glyphicon glyphicon-ok';
        const missingClasses = classNames({
            'confidenceFilter': true,
            'missing': true,
            'active': showConfidenceMissing
        });

        const uncertainClasses = classNames({
            'confidenceFilter': true,
            'uncertain': true,
            'active': showConfidenceUncertain
        });

        const confidentClasses = classNames({
            'confidenceFilter': true,
            'confident': true,
            'active': showConfidenceConfident
        });

        const synchronizedClasses = classNames({
            'confidenceFilter': true,
            'synchronized': true,
            'active': showSynchronizedObjects
        });

        return (
            <div className={'confidence-filters'}>
                <h1 className={'h4'}>
                    Visningsvalg
                </h1>
                <label className={missingClasses}>
                    <input type={'checkbox'}
                           checked={showConfidenceMissing}
                           onChange={() => this.toggleFilterState(LocationalConfidence.missing)}
                    />
                    <span className={'placeholder-checkbox'}>
                        <i className={checkedIconClass}/>
                    </span>
                    <span className={'confidence-label'}>
                        <ConfidenceIcon type={LocationalConfidence.missing}/>
                        Mangler stedfesting
                    </span>
                </label>
                <label className={uncertainClasses}>
                    <input type={'checkbox'}
                           checked={showConfidenceUncertain}
                           onChange={() => this.toggleFilterState(LocationalConfidence.uncertain)}
                    />
                    <span className={'placeholder-checkbox'}>
                        <i className={checkedIconClass}/>
                    </span>
                    <span className={'confidence-label'}>
                        <ConfidenceIcon type={LocationalConfidence.uncertain}/>
                        Usikker stedfesting
                    </span>
                </label>
                <label className={confidentClasses}>
                    <input type={'checkbox'}
                           checked={showConfidenceConfident}
                           onChange={() => this.toggleFilterState(LocationalConfidence.confident)}
                    />
                    <span className={'placeholder-checkbox'}>
                        <i className={checkedIconClass}/>
                    </span>
                    <span className={'confidence-label'}>
                        <ConfidenceIcon type={LocationalConfidence.confident}/>
                        Sikkert stedfestet
                    </span>
                </label>
                <label className={synchronizedClasses}>
                    <input type={'checkbox'}
                           checked={showSynchronizedObjects}
                           onChange={() => this.toggleSynchronizedObjects()}
                    />
                    <span className={'placeholder-checkbox'}>
                        <i className={checkedIconClass}/>
                    </span>
                    <span className={'confidence-label'}>
                        <ConfidenceIcon type={LocationalConfidence.confident} synchronized/>
                        Registrert i NVDB
                    </span>
                </label>
            </div>
        );
    }

    toggleFilterState(filter: LocationalConfidence) {
        this.props.doToggleConfidenceFilter(filter);
    }
    toggleSynchronizedObjects() {
        this.props.doToggleSynchronizedObjects();
    }

}

export const ConfidenceFilters = connect(mapStateToProps, mapDispatchToProps)(Component);